import { UnclaimedMoneyItem, UnclaimedSearchResult } from "@/types/unclaimed";
import { POST } from ".";

export type InitDeviceRequest = {
  token: string;
  platform?: "ios" | "android" | "web";
  deviceInfo?: {
    deviceId?: string;
    deviceName?: string;
    osVersion?: string;
    appVersion?: string;
  };
};

const NotificationServices = {
  /**
   * @returns Promise<ApiResponse<null>>
   */
  initDevice: async (request: InitDeviceRequest) => {
    return await POST<null>(`/user/init-device`, request);
  },
  sendTestNotification: async () => {
    return await POST<null>(`/user/test-notification`);
  },
};

export default NotificationServices;
